var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.countryCollection ? _vm.countryCollection.models : [],"item-text":_vm.itemText,"item-value":_vm.itemValue,"label":_vm.label,"dense":"","outlined":""}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }